<div class="border-divider bg-card sticky top-0 z-40 hidden w-full rounded-full border lg:block">
    <div class="mx-auto flex items-center gap-3 px-4 py-1">
        <div
            class="clock-status"
            [class.status-running]="time.isRunning() && !time.isPaused()"
            [class.status-paused]="time.isPaused()"
            role="status"
        ><mat-icon aria-hidden="true">{{ time.isPaused() ? 'pause' : time.isRunning() ? 'play_arrow' : 'stop' }}</mat-icon>
            <span>{{ (time.isPaused() ? 'timeTracker.statusPaused' : time.isRunning() ? 'timeTracker.statusRunning' : 'timeTracker.statusStopped') | transloco }}</span>
        </div>

        <!-- Timers -->
        <div class="flex min-w-0 flex-1 flex-col items-center justify-items-center">
            <div class="truncate font-mono text-lg tracking-tight">
                {{ time.formatHM(time.elapsedSeconds()) }}
            </div>
            <div class="font-mono text-sm text-secondary" *ngIf="time.totalPauseSeconds() as pause">
                {{ 'timeTracker.pause' | transloco }}: {{ time.formatHM(pause) }}
            </div>
        </div>

        <!-- Actions -->
        <div class="flex items-center gap-2">
            <button
                class="text-sm"
                mat-icon-button
                [matTooltip]="'timeTracker.details' | transloco"
                [attr.aria-label]="'timeTracker.details' | transloco"
                (click)="openDetails()"
            >
                <mat-icon>more_horiz</mat-icon>
            </button>

            @if (!time.apiLoading()) {
                @if (!time.isRunning() && !time.isPaused()) {
                    <button
                        mat-button
                        color="primary"
                        class="max-h-none rounded-sm px-3 text-sm"
                        (click)="time.start()"
                        [disabled]="time.isRunning() || time.isPaused() || time.apiLoading()"
                    >
                        <mat-icon class="mr-2">play_arrow</mat-icon>
                        <span class="hidden sm:block">{{ 'timeTracker.start' | transloco }}</span>
                    </button>
                }

                @if (time.isRunning()) {
                    <button
                        mat-button
                        color="warn"
                        class="max-h-none rounded-sm px-3 text-sm"
                        (click)="time.pause()"
                        [disabled]="!time.isRunning() || time.apiLoading()"
                    >
                        <mat-icon class="mr-2">pause</mat-icon>

                        <span class="hidden sm:block">{{ 'timeTracker.pause' | transloco }}</span>
                    </button>
                }

                @if (time.isPaused()) {
                    <button
                        mat-button
                        color="primary"
                        class="max-h-none rounded-sm px-3 text-sm"
                        (click)="time.resume()"
                        [disabled]="!time.isPaused() || time.apiLoading()"
                    >
                        <mat-icon class="mr-2">play_circle</mat-icon>
                        <span class="hidden sm:block">{{ 'timeTracker.continue' | transloco }}</span>
                    </button>
                }

                @if (time.isRunning()) {
                    <button
                        mat-button
                        class="max-h-none rounded-sm px-3 text-sm"
                        (click)="time.stop()"
                        [disabled]="time.isPaused() || time.apiLoading() || !time.isRunning()"
                    >
                        <mat-icon class="mr-2">stop</mat-icon>

                        <span class="hidden sm:block">{{ 'timeTracker.stop' | transloco }}</span>
                    </button>
                }
            }
            <mat-progress-spinner *ngIf="time.apiLoading()" diameter="20" mode="indeterminate"></mat-progress-spinner>
        </div>
    </div>
</div>
<div
    class="mobile-clock border-divider bg-card flex min-w-0 items-center rounded-full border lg:hidden"
>
    <!-- The time also opens the details when the separate button is hidden. -->
    <button
        type="button"
        class="mobile-clock-summary"
        [matTooltip]="'timeTracker.details' | transloco"
        [attr.aria-label]="('timeTracker.details' | transloco) + ': ' + time.formatHM(time.elapsedSeconds())"
        (click)="openDetails()"
    >
        <span class="clock-status" [class.status-running]="time.isRunning()" [class.status-paused]="time.isPaused()" role="status">
            <mat-icon aria-hidden="true">{{ time.isPaused() ? 'pause' : time.isRunning() ? 'play_arrow' : 'stop' }}</mat-icon>
            <span>{{ (time.isPaused() ? 'timeTracker.statusPaused' : time.isRunning() ? 'timeTracker.statusRunning' : 'timeTracker.statusStopped') | transloco }}</span>
        </span>
        <span class="block max-w-full truncate font-mono text-lg tabular-nums leading-5 tracking-tight">
            {{ time.formatHM(time.elapsedSeconds()) }}
        </span>
    </button>

    <!-- Compact controls show only actions available in the current state. -->
    <div class="flex shrink-0 items-center gap-0.5">
        @if (time.apiLoading()) {
            <mat-progress-spinner class="mx-3" [diameter]="20" mode="indeterminate"></mat-progress-spinner>
        } @else if (time.isPaused()) {
            <button
                mat-icon-button
                type="button"
                class="h-11 w-11 shrink-0 p-2.5 sm:h-12 sm:w-12 sm:p-3"
                [matTooltip]="'timeTracker.continue' | transloco"
                [attr.aria-label]="'timeTracker.continue' | transloco"
                (click)="time.resume()"
            >
                <mat-icon>play_circle</mat-icon>
            </button>
        } @else if (time.isRunning()) {
            <button
                mat-icon-button
                type="button"
                class="h-11 w-11 shrink-0 p-2.5 sm:h-12 sm:w-12 sm:p-3"
                [matTooltip]="'timeTracker.pause' | transloco"
                [attr.aria-label]="'timeTracker.pause' | transloco"
                (click)="time.pause()"
            >
                <mat-icon>pause</mat-icon>
            </button>
            <button
                mat-icon-button
                type="button"
                class="h-11 w-11 shrink-0 p-2.5 sm:h-12 sm:w-12 sm:p-3"
                [matTooltip]="'timeTracker.stop' | transloco"
                [attr.aria-label]="'timeTracker.stop' | transloco"
                (click)="time.stop()"
            >
                <mat-icon>stop</mat-icon>
            </button>
        } @else {
            <button
                mat-icon-button
                type="button"
                class="h-11 w-11 shrink-0 p-2.5 sm:h-12 sm:w-12 sm:p-3"
                [matTooltip]="'timeTracker.start' | transloco"
                [attr.aria-label]="'timeTracker.start' | transloco"
                (click)="time.start()"
            >
                <mat-icon>play_arrow</mat-icon>
            </button>
        }
    </div>
</div>
